<template>

  <sc-table
    :data="invoiceOrderItems"
    :loading="loadingInvoiceOrderItems"
    :paginated="true"
    :backend-pagination="true"
    :total="totalInvoiceOrderItems"
    :per-page="invoiceOrderItemsPagination.limit"
    :current-page="invoiceOrderItemsPagination.page"
    @page-change="(page) => invoiceOrderItemsPagination.page = page"
    class="tab-order-items">

    <template slot-scope="props">
      <sc-table-column
        field="invoice-number"
        label="Item da fatura"
        :centered="false"
        sortable>
        {{ invoice.reconciliation_invoice_number }}
      </sc-table-column>

      <sc-table-column
        field="shipment_order_number"
        label="Pedido"
        sortable>
        <a
          :href="`/ng#/order-number/${props.row.shipment_order_number}`"
          v-if="props.row.shipment_order_number">
          {{ props.row.shipment_order_number }}
        </a>
        <span v-if="!props.row.shipment_order_number">
          Sem pedido
        </span>
      </sc-table-column>

      <sc-table-column
        field="description"
        :width="150"
        label="CTe">
        <span v-if="!props.row.cte_number">Sem CTe</span>
        <div
          class="level is-paddingless"
          v-if="props.row.cte_number">

          <div class="level-left">{{ props.row.cte_number }}</div>

          <div class="level-right" v-if="props.row.cte_file_attachment">
            <div class="field has-addons">
              <p class="control">
                <button
                  type="button"
                  class="button is-info is-small"
                  @click="openFilesGallery(props.row.cte_file_attachment)">
                  <sc-icon
                    icon="eye"
                    size="is-small" />
                </button>
              </p>
              <p class="control">
                <a
                  class="button is-primary is-small"
                  :href="props.row.cte_file_attachment.url"
                  target="_blank"
                  download>
                  <sc-icon
                    icon="cloud-download-alt"
                    size="is-small" />
                </a>
              </p>
            </div>
          </div>
        </div>
      </sc-table-column>

    </template>

    <template slot="empty">
      <sc-table-empty />
    </template>

    <template slot="bottom-left">
      <sc-table-per-page v-model="invoiceOrderItemsPagination.limit" />
    </template>

  </sc-table>
</template>

<script>
  import {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
    ScIcon,
    ScFilesGallery,
  } from '@intelipost-js/secure-components';
  import { Lodash } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions } = createNamespacedHelpers('recon/invoiceAudit');

  export default {
    name: 'tab-invoice-audit-detail-order-items',
    data() {
      return {
        invoiceOrderItemsPagination: Lodash.cloneDeep(
          this.$store.state.recon.invoiceAudit.invoiceOrderItemsPagination,
        ),
      };
    },
    watch: {
      invoiceOrderItemsPagination: {
        handler(newPagitation) {
          this.$store.commit('recon/invoiceAudit/setInvoiceOrderItemsPagination', newPagitation);
          this.getInvoiceOrderItems(this.invoice.reconciliation_invoice_id);
        },
        deep: true,
      },
    },
    computed: {
      ...mapState([
        'invoice',
        'loadingInvoiceOrderItems',
        'invoiceOrderItems',
        'totalInvoiceOrderItems',
      ]),
    },
    methods: {
      ...mapActions([
        'getInvoiceOrderItems',
      ]),
      openFilesGallery(file) {
        ScFilesGallery.open(this.$instance, {
          selected: {
            fileName: file.name,
            fileUrl: file.url,
            mimeType: file.mime_type,
          },
          files: this.invoiceOrderItems
            .filter(item => item.cte_file_attachment)
            .map(item => ({
              fileName: item.cte_file_attachment.name,
              fileUrl: item.cte_file_attachment.url,
              mimeType: item.cte_file_attachment.mime_type,
            })),
        });
      },
    },
    beforeMount() {
      this.getInvoiceOrderItems(this.invoice.reconciliation_invoice_id);
    },
    components: {
      ScTable,
      ScTableColumn,
      ScTableEmpty,
      ScTablePerPage,
      ScIcon,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/components/tab-order-items/TabInvoiceAuditDetailOrderItems.vue?d4606a16